/* eslint-disable no-console */
/* eslint-disable no-undef */
import ReactPixel from 'react-facebook-pixel';
import ReactGA from 'react-ga4';
import { openUnpaidInvoicesModal } from '../Templates/Settings/Billing/BillingModals';
import { ajaxActions } from './AjaxActions';
import { ToastS } from './ToastS';
import { ConstantS } from './ConstantS';
import { MixpanelS } from './MixpanelS';
import { CookiesS } from './CookiesS';

const cbInstance = Chargebee.init({
  site: process.env.REACT_APP_CHARGEBEE_SITE,
  enableGTMTracking: true,
});

const BASE_URL = `${process.env.REACT_APP_PAYMENT_SERVICE_URL}/chargebee`;

if (cbInstance) {
  cbInstance.setPortalSession(() =>
    ajaxActions.get(`${BASE_URL}/portal-session`).then((res) => {
      if (res.ok) {
        return res.json();
      }
      console.error('Unable to create portal session');
      return null;
    }),
  );
} else {
  console.error('Unable to initialize chargebee');
}

const verifyCheckout = (hostedPageId, onSuccess, billingPlan) =>
  ajaxActions.get(`${BASE_URL}/verify-checkout?hostedPageId=${hostedPageId}`).then((resp) => {
    if (resp.ok) {
      onSuccess();
      if (!billingPlan) return;
      const { price, name } = billingPlan;
      ReactGA.event({ category: 'Billing', action: ConstantS.TrackingEvents.Purchase, label: name, value: price });
      ReactPixel.track(ConstantS.TrackingEvents.Purchase, { content_name: name, currency: 'EUR', value: price });
      MixpanelS.track(ConstantS.TrackingEvents.Purchase, { content_name: name, currency: 'EUR', value: price });
    } else {
      console.warn(`Unable to verify checkout for hostedPage: ${hostedPageId}`);
    }
  });

const openHostedCheckout = (planId, refreshToken, billingPlan, coupon) => {
  const { price, name } = billingPlan;
  ReactGA.event({ category: 'Billing', action: ConstantS.TrackingEvents.InitiateCheckout, label: name, value: price });
  ReactPixel.track(ConstantS.TrackingEvents.InitiateCheckout, { currency: 'EUR', value: price });
  MixpanelS.track(ConstantS.TrackingEvents.InitiateCheckout, { currency: 'EUR', value: price });
  if (cbInstance) {
    cbInstance.openCheckout({
      hostedPage: () => {
        let targetUrl = `${BASE_URL}/hosted-checkout?planId=${planId}`;
        if (coupon) {
          targetUrl += `&coupon=${coupon}`;
        }
        let firstPromoterTrackingId = CookiesS.getCookiePayload("_fprom_tid");
        if (firstPromoterTrackingId) {
          console.log("adding trackingId " + firstPromoterTrackingId);
          targetUrl += `&trackingId=${firstPromoterTrackingId}`;
        }
        return ajaxActions.get(targetUrl).then((resp) => {
          if (resp.ok) {
            return resp.json();
          }
          if (resp.status === 412) {
            openUnpaidInvoicesModal();
            return null;
          }
          console.error('Unable to open hosted checkout');
          ToastS.generalError();
          return null;
        });
      },
      success: (hostedPageId) => verifyCheckout(hostedPageId, refreshToken, billingPlan),
    });
  }
};

const openHostedAddonCheckout = (addonId, quantity, onSuccess) => {
  if (cbInstance) {
    cbInstance.openCheckout({
      hostedPage: () => {
        const targetUrl = `${BASE_URL}/hosted-checkout/addon?addonId=${encodeURIComponent(
          addonId,
        )}&quantity=${quantity}`;
        return ajaxActions.get(targetUrl).then((resp) => {
          if (resp.ok) {
            return resp.json();
          }
          if (resp.status === 412) {
            openUnpaidInvoicesModal();
            return null;
          }
          console.error('Unable to open addon hosted checkout');
          ToastS.generalError();
          return null;
        });
      },
      success: (hostedPageId) => verifyCheckout(hostedPageId, onSuccess),
    });
  }
};

const migrateExistingSubscription = (onSuccess) => {
  if (cbInstance) {
    cbInstance.openCheckout({
      hostedPage: () => {
        const targetUrl = `${process.env.REACT_APP_PAYMENT_SERVICE_URL}/subscriptions/migrate`;
        return ajaxActions.get(targetUrl).then((resp) => {
          if (resp.ok) {
            return resp.json();
          }
          console.error('Unable to open hosted checkout');
          ToastS.generalError();
          return null;
        });
      },
      success: (hostedPageId) => verifyCheckout(hostedPageId, onSuccess),
    });
  }
};

const openPortal = (onClose, section) => {
  if (cbInstance) {
    const cbPortal = cbInstance.createChargebeePortal();
    if (cbPortal) {
      const portalSections = Chargebee?.getPortalSections?.();
      const sectionType = section ? portalSections?.[section] || section : undefined;
      if (sectionType) {
        cbPortal.open(
          {
            close: onClose,
          },
          {
            sectionType,
          },
        );
      } else {
        cbPortal.open({
          close: onClose,
        });
      }
    } else {
      ToastS.generalError();
      console.error('Unable to create portal');
    }
  }
};

// eslint-disable-next-line import/prefer-default-export
export const ChargebeeS = {
  openHostedCheckout,
  openHostedAddonCheckout,
  openPortal,
  migrateExistingSubscription,
};
